// components/product/ProductVariants.jsx
import React from "react";
import { FiHardDrive, FiCheckCircle, FiCircle } from "react-icons/fi";

const ProductVariants = ({
  variants,
  selectedVariant,
  onVariantSelect,
  isDarkMode,
}) => {
  if (!variants || variants.length === 0) return null;

  const getVariantLabel = (variant) => {
    // Try to get from attributes first
    if (variant.attributes && variant.attributes.length > 0) {
      const variantAttr = variant.attributes.find(
        (attr) => attr.attribute_name === "VARIANT",
      );
      if (variantAttr && variantAttr.value_name) {
        return variantAttr.value_name;
      }
    }
    // Fallback to extracting from title
    const match = variant.title?.match(/\(([^)]+)\)/);
    return match ? match[1] : variant.title || "";
  };

  return (
    <div
      className={`p-4 mb-4 rounded-xl ${
        isDarkMode ? "bg-gray-700" : "bg-gray-50"
      }`}
    >
      <div className="flex items-center justify-center mb-3">
        <div className="flex items-center">
          <div
            className={`w-6 h-0.5 ${isDarkMode ? "bg-gray-600" : "bg-gray-300"}`}
          ></div>
          <div className="flex items-center gap-2 mx-3">
            <h3
              className={`text-sm font-semibold ${
                isDarkMode ? "text-gray-200" : "text-gray-700"
              }`}
            >
              Select Variant
            </h3>
          </div>
          <div
            className={`w-6 h-0.5 ${isDarkMode ? "bg-gray-600" : "bg-gray-300"}`}
          ></div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {variants.map((variant) => {
          const isSelected = selectedVariant?.id === variant.id;
          const label = getVariantLabel(variant);

          return (
            <div
              key={variant.id}
              onClick={() => onVariantSelect(variant)}
              className={`p-3 transition-all duration-300 cursor-pointer rounded-xl border-2 ${
                isSelected
                  ? isDarkMode
                    ? "border-emerald-500 bg-gray-600 shadow-md"
                    : "border-emerald-500 bg-white shadow-md"
                  : isDarkMode
                    ? "border-gray-600 bg-gray-800 hover:border-gray-500"
                    : "border-gray-200 bg-white hover:border-emerald-300 hover:shadow-sm"
              }`}
            >
              <div className="flex items-start">
                <div
                  className={`mr-2 mt-0.5 ${
                    isSelected
                      ? "text-emerald-500"
                      : isDarkMode
                        ? "text-gray-500"
                        : "text-gray-400"
                  }`}
                >
                  {isSelected ? (
                    <FiCheckCircle size={16} />
                  ) : (
                    <FiCircle size={16} />
                  )}
                </div>
                <div className="flex-1">
                  <p
                    className={`text-xs font-bold ${
                      isSelected
                        ? isDarkMode
                          ? "text-white"
                          : "text-gray-900"
                        : isDarkMode
                          ? "text-gray-300"
                          : "text-gray-700"
                    }`}
                  >
                    {label}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductVariants;
